/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as commonV1 from "./deviceapis_device_common_v1.pb"

/**
 * Сервис управления настройками Ticker
 */

/**
 * Сервис управления настройками Ticker
 */
export class TickerServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод редактирования настроек Ticker
   */
  EditTicker = (req: Pick<EditTickerRequestDto, "updateMask"> & { data: TickerRequestDto & fm.RequireAtLeastOne<TickerRequestDto> }, init?: RequestInit): Promise<EditTickerResponseDto> => {
    return fm.request<Pick<EditTickerRequestDto, "updateMask"> & { data: TickerRequestDto & fm.RequireAtLeastOne<TickerRequestDto> }, EditTickerResponseDto>(`${this.host}/device/api/v1/ticker`, { ...init, method: "PATCH", body: JSON.stringify(req.data, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения настроек Ticker
   */
  GetTicker = (req?: GetTickerRequestDto, init?: RequestInit): Promise<GetTickerResponseDto> => {
    return fm.request<GetTickerRequestDto, GetTickerResponseDto>(`${this.host}/device/api/v1/ticker${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Режим строки
 */
export enum TickerModeType {
  /**
   * Значение не указано
   */
  MODE_TYPE_UNKNOWN = "MODE_TYPE_UNKNOWN",
  /**
   * Выключен
   */
  OFF = "OFF",
  /**
   * Бегущая строка
   */
  RUNNING_LINE = "RUNNING_LINE",
  /**
   * Строка одна за другой
   */
  LINE_1_BY_1 = "LINE_1_BY_1",
}
/**
 * Режим строки
 */
export type TickerModeTypeResponseEnum = keyof typeof TickerModeType
/**
 * Режим строки
 */
export type TickerModeTypeRequestEnum = Exclude<TickerModeTypeResponseEnum, "MODE_TYPE_UNKNOWN">;

/**
 * Запрос настройки Ticker
 */
export type EditTickerRequestDto = {
  /**
   * Настройки Ticker
   */
  data: TickerRequestDto
  /**
   * Маска полей обновления
   */
  updateMask?: string | null
}
/**
 * Ответ на запрос настройки Ticker
 */
export type EditTickerResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: EditTickerResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type EditTickerResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type EditTickerResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения настроек Ticker
 */
export type GetTickerRequestDto = {
}
/**
 * Ответ на апрос получения настроек Ticker
 */
export type GetTickerResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Настройки Ticker
   */
  readonly data: TickerResponseDto
}>
/**
 * Настройки Ticker
 */
export type TickerRequestDto = {
  /**
   * Режим строки
   */
  modeType?: TickerModeTypeRequestEnum | "MODE_TYPE_UNKNOWN"
  /**
   * Скорость, символов в минуту
   */
  speed?: number
  /**
   * Задержка смены строки, секунд
   */
  delay?: number
  /**
   * Строки
   */
  lines?: string[]
}
/**
 * Настройки Ticker
 */
export type TickerResponseDto = {
  /**
   * Режим строки
   */
  modeType: TickerModeTypeResponseEnum
  /**
   * Скорость, символов в минуту
   */
  speed: number
  /**
   * Задержка смены строки, секунд
   */
  delay: number
  /**
   * Строки
   */
  lines: string[]
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос настройки Ticker
   */
  "EditTickerRequest": {
    "kind": "class",
    "text": "Запрос настройки Ticker",
    "fields": {
      /**
       * Настройки Ticker
       */
      "data": {
        "type": "Ticker",
        "text": "Настройки Ticker",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Маска полей обновления
       */
      "updateMask": {
        "type": "google.protobuf.FieldMask",
        "text": "Маска полей обновления",
      },
    },
  },
  /**
   * Ответ на запрос настройки Ticker
   */
  "EditTickerResponse": {
    "kind": "class",
    "text": "Ответ на запрос настройки Ticker",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "EditTickerResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "EditTickerResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения настроек Ticker
   */
  "GetTickerRequest": {
    "kind": "class",
    "text": "Запрос получения настроек Ticker",
  },
  /**
   * Ответ на апрос получения настроек Ticker
   */
  "GetTickerResponse": {
    "kind": "class",
    "text": "Ответ на апрос получения настроек Ticker",
    "fields": {
      /**
       * Настройки Ticker
       */
      "data": {
        "type": "Ticker",
        "text": "Настройки Ticker",
      },
    },
  },
  /**
   * Настройки Ticker
   */
  "Ticker": {
    "kind": "class",
    "text": "Настройки Ticker",
    "fields": {
      /**
       * Режим строки
       */
      "modeType": {
        "type": "Ticker.ModeType",
        "text": "Режим строки",
      },
      /**
       * Скорость, символов в минуту
       */
      "speed": {
        "type": "int32",
        "text": "Скорость, символов в минуту",
      },
      /**
       * Задержка смены строки, секунд
       */
      "delay": {
        "type": "int32",
        "text": "Задержка смены строки, секунд",
      },
      /**
       * Строки
       */
      "lines": {
        "type": "string",
        "text": "Строки",
      },
    },
  },
  /**
   * Режим строки
   */
  "Ticker.ModeType": {
    "kind": "enum",
    "text": "Режим строки",
    "values": {
      /**
       * Значение не указано
       */
      "MODE_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Выключен
       */
      "OFF": {
        "i": 1,
        "text": "Выключен",
      },
      /**
       * Бегущая строка
       */
      "RUNNING_LINE": {
        "i": 2,
        "text": "Бегущая строка",
      },
      /**
       * Строка одна за другой
       */
      "LINE_1_BY_1": {
        "i": 3,
        "text": "Строка одна за другой",
      },
    },
  },
}